export default class Banner {
    constructor() {
        this.id = null;
        this.image = null;
        this.imageUrl = '';
        this.link = '';
        this.active = true;
        this.position = 0;
        this.altTexts = {
            1: '', // Portuguese
            2: '', // English
            3: ''  // Spanish
        };
    }

    isValid() {
        if (!this.image) return false;
        return Object.values(this.altTexts).every(value => value && value.trim() !== '');
    }
}
